module.exports = __webpack_public_path__ + "img/ol-icon-white.34f7b11a.svg";